<!--
	作者：Shujuan Sun
	时间：2017-04-19
	描述：监控平台页面-底部选项卡组件
-->
<template>
	<div class="bottomTab" :class="{'activ_magnify':magnify,'midSizeL':leftSize==1,'maxSizeL':leftSize==2,'minSizeL':leftSize==0,'minSizeR':rightSize == 0,'maxSizeR':rightSize == 2, 'midSizeR':rightSize == 1}">
		<!-- 车辆监控页面_底部车辆列表开始 -->
		<div class="tab-vertical-bottom tab-vertical" v-loading="loadBottom" element-loading-text="加载中">
		  <div class="tabB-header">
			<div class="tabsB">
			    <div class="innerTabsB">
			      	<div class="tab-itemB" :class="{active:curIndex === 0}" @click="goList" ref="profile">
			      		<span style="display: inline-block;">车辆一览</span>
			      	</div>
			        <div class="tab-itemB" v-for="(tab,index) in tabFollowList" :class="{active:curIndex === tab.id}" @click="goTab(tab.id)" ref="profile">
			        	<span style="display: inline-block;">{{tab.tagpanelName}}</span>
			        	<i v-if="tab.isEmpty" @click="delFollowPanel(tab.id,tab.tagpanelName)">X</i>
			        </div>	        
			    </div>
			</div>
			<div class="btn4a btn_ico02" @click="minSize" data-toggle="seltip" data-placement="right" title="最小"></div>
			<div class="btn4b btn_ico02" @click="zoomOut" data-toggle="seltip" data-placement="right" title="半高"></div>
		    <div class="btn4c btn_ico02" @click="zoomIn" data-toggle="seltip" data-placement="right" title="最大"></div>
		    <div id="btnUpB" class="btn1 btn_ico01"  @mousedown="leftMouseDown" @mouseup="handleMouseUp" data-toggle="seltip" data-placement="right" title="左移"></div>
		    <div id="btnDownB" v-show="showRBtn" class="btn2 btn_ico01" @mousedown="rtMouseDown" @mouseup="handleMouseUp" data-toggle="seltip" data-placement="left" title="右移"></div>
		  </div>
		    <div class="dropdown dropdown_bottom">
				<a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> 
					<i class="btn5 btn_ico02" data-toggle="seltip" data-placement="bottom" title="显示菜单"></i> 
				</a>
				<ul class="dropdown_menu list-group list03 dropdown_bottom_ul" id="menuL" aria-labelledby="dLabel">
					<li class="list_group_item" :class="{active:curIndex===0}" @click="goList">车辆一览</li>
					<li class="list_group_item" v-for="(tab,index) in tabFollowList" @click="goTab(tab.id)" :class="{active:curIndex===tab.id}">{{tab.tagpanelName}}</li>				
				</ul>
		    </div>
		  <div class="tab-bodyB tab-selected" >
		    <div class="tab-contentB">
			    <vehicle-list 
			        v-show="curIndex===0"
			        v-on:updateTip="updateTip"
			       	>
			    </vehicle-list>
			    <vehicle-follow
			      	v-for="(followPanel,index) in followList"
			      	key="index"
			      	v-show="curIndex==followPanel.id"
			      	:followObj="followPanel.vehicleMonitorStatistics"
			      	v-on:updateTip="updateTip"
			    	>
			    </vehicle-follow>
		    </div>		
		  </div>
		</div>
		<!-- 车辆监控页面_底部车辆列表结束 -->
		<!--点击底部面板设备图标弹出小浮动窗口-->
		<vehicle-device
			v-if="deviceListComp"
		>
		</vehicle-device>
	</div>
</template>
<script>
	import VehicleDevice from './VehicleDevice'
	import VehicleFollow from './VehicleFollow'
	import {OPERATE_EXCEPTION,EXPORT_EXCEPTION} from 'static/message'
	import VehicleList from './VehicleList'
	import {mapState} from 'vuex'
	export default{
		name:'TabSelected',
		components:{
			VehicleList,
			VehicleFollow,
			VehicleDevice
		},
		data(){
			return {
				followList:[],
				showRBtn:false,
				isEnlarge:true //是否点击放大按钮
			}
		},
		computed:{
			...mapState({
				loadBottom:state=>state.monitor.loadBottom,
				curIndex:state=>state.monitor.curIndex,
				tabFollowList:state=>state.monitor.tabFollowList,
				magnify:state=>state.monitor.magnify, //面板处于缩小状态，可以点击放大
				deviceListComp:state=>state.monitor.deviceListComp,  //是否显示设备一览
				rightSize:state=>state.monitor.rightSize,
				leftSize:state=>state.monitor.leftSize,
				bottomSize:state=>state.monitor.bottomSize
			})
		},
		watch:{
			tabFollowList(val){
				this.followList = val 
			},
			'tabFollowList.length'(val){ 
				this.$nextTick(()=>{
					if(this.getScrollWidthB() > $('.tab-vertical-bottom .tabB-header').width() - 64){ 
						this.showRBtn = true
					}else{ 
						this.showRBtn = false
					}
				})
				
			},
			bottomSize(val){
				if(val == 0){//最小 
					$('.bottomTab').height('24px');
					$('.bottomTab .tab-selected').css({display:'none'});
				}else if(val == 1){//半高
					$('.bottomTab').height('175px');
					$('.bottomTab .tab-selected').css('display','block')
				}else{//最大
					$('.bottomTab').height('80%');
					$('.bottomTab .tab-selected').css('display','block')
				}
			}
		},
		beforeMount(){
			this.$nextTick(()=>{
				const that = this
				window.onresize = function temp(){
					if(that.getScrollWidthB() > $('.tab-vertical-bottom .tabB-header').width() - 64){
						that.showRBtn = true
					}else{
						that.showRBtn = false
					}
				}
				$(function () {//启用tooltip
				  $('[data-toggle="seltip"]').tooltip()
				})  
				if(this.bottomSize == 0){//最小 
					$('.bottomTab').height('24px');
					$('.bottomTab .tab-selected').css({display:'none'});
				}else if(this.bottomSize == 1){//半高
					$('.bottomTab').height('175px');
					$('.bottomTab .tab-selected').css('display','block')
				}else{//最大
					$('.bottomTab').height('80%');
					$('.bottomTab .tab-selected').css('display','block')
				}
			})
			this.$store.dispatch('getFollowList')//获取用户原有关注面板信息（不含车辆）
			this.$store.dispatch('getAllFollow')//初始化用户关注面板信息
			this.$store.dispatch('clearAllList') //清空车辆一览面板信息
		},
		beforeDestroy(){
		//	this.$store.dispatch('clearAllList') //清空车辆一览面板信息
			$('[data-toggle="seltip"]').tooltip('hide')
		},
		methods:{
			updateTip(){
				this.$nextTick(function(){ 
				 $('[data-toggle="seltip"]').tooltip({
				  	container:'body'
				 })
			 	$('.tip').hover(function(e){
			 		if($(e.currentTarget).attr('tip')==''){
			 			$(e.currentTarget).attr('data-original-title','')
			 			return
			 		}else{
			 			$(e.currentTarget).attr('data-original-title',$(e.currentTarget).attr('tip')).tooltip('fixTitle').tooltip('show')
			 		}
			 	},function(e){
			 		$(e.currentTarget).attr('data-original-title','')
			 	})
			 	$('.list-complete-item').bind('selectstart',function(){
				  	return false
				})
			 })
			},
			delFollowPanel(id,name){//删除关注面板
				const obj = {
					panelId:id,
					panelName:name,
					type:'panel'
				}
				this.$store.dispatch('deleteModalShow',obj)
			},
			goList(){//返回底部一览面板
				this.$store.dispatch('goVehicleList')
				let h = $('.bottomTab').height()
					if(h==24){
						h = 175
					}
				$('.bottomTab').height(h + 'px'); 
				$('.bottomTab .tab-selected').css('display','block')
			},
			goTab(id){//关注面板间切换
				this.$store.dispatch('goPanel',id)
					let h = $('.bottomTab').height()
					if(h==24){
						h = 175
					}
				$('.bottomTab').height(h + 'px');
				$('.bottomTab .tab-selected').css('display','block')
			},
			minSize(){//最小状态下-点击变最小 
				this.$store.dispatch('changeBottomSize',0)
			},
			zoomIn(){//放大至满屏的3/4 
			//	this.isEnlarge = false;
				this.$store.dispatch('changeBottomSize',2)
			},
			zoomOut(){//缩小至一行 
			//	this.isEnlarge = true;
				this.$store.dispatch('changeBottomSize',1)
			},
			leftMouseDown(){
				if(this.getScrollWidthB() > $('.tab-vertical-bottom .tabB-header').width()){
					$('.tab-vertical-bottom .innerTabsB').animate({left:"0"},"slow")
				}
			},
			rtMouseDown(){
				if(this.getScrollWidthB() > $('.tabB-header').width()){
					$('.tab-vertical-bottom .innerTabsB').animate({left: "-"+ this.getScrollDeltaXB() + "px"},"slow")				
				}	
			},
			handleMouseUp(){
				$('.tab-vertical-bottom .innerTabsB').stop()
			},
			getScrollWidthB(){//最后是innerTabsB的总宽度
				var labelWidth = 0;
				$('.tab-vertical-bottom .tab-itemB').each(function(){
					labelWidth += $(this).outerWidth(true)
				})
				return labelWidth + 68;
			},
			getScrollDeltaXB(){
				return this.getScrollWidthB()-$('.tab-vertical-bottom .tabB-header').innerWidth()+24;
			}
		}
		
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// TabSelected.vue?05226610